import { useCallback, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

export const DEFAULT_OPTS = {
  bookingType: "one_way", recurringKind: "one_way", returnWait: 15, payment: "end_of_week", vehicle: "xl",
  when: "now", scheduledAt: "", days: [], weeks: 4, passengers: 1, discountCode: "", payMethod: "pay_at_pickup", payRemainder: "pay_at_pickup",
};
export const isMultiStop = (opts) => (opts.bookingType === "recurring" ? opts.recurringKind : opts.bookingType) === "multi_stop";

export function buildTrip({ pickup, dropoff, stops, opts }) {
  const recurring = opts.bookingType === "recurring";
  const tripType = recurring ? opts.recurringKind : opts.bookingType;
  const multi = tripType === "multi_stop";
  if (!pickup || !dropoff || (multi && (!stops.length || stops.some((s) => !s.place)))) return null;
  const later = recurring || opts.when === "later";
  if (later && !opts.scheduledAt) return null;
  if (recurring && !opts.days.length) return null;
  return {
    pickup,
    dropoff,
    stops: multi ? stops.map((s) => ({ ...s.place, wait_minutes: s.wait })) : [],
    vehicle_class: opts.vehicle,
    passengers: opts.passengers || 1,
    trip_type: tripType,
    return_wait_minutes: tripType === "round_trip" ? opts.returnWait : 0,
    ride_type: opts.bookingType,
    recurring_payment: opts.payment,
    scheduled_at: later ? new Date(opts.scheduledAt).toISOString() : null,
    recurrence: recurring ? { days: opts.days, weeks: opts.weeks } : null,
    discount_code: opts.discountCode || null,
    payment_method: opts.payMethod,
    secondary_payment_method: opts.payMethod === "ride_credit" ? opts.payRemainder : null,
  };
}

export function useQuote(trip, riderId, path = "/pricing/quote") {
  const [state, setState] = useState({ data: null, loading: false, error: "" });
  const [nonce, setNonce] = useState(0);
  const key = JSON.stringify(trip);
  const retry = useCallback(() => setNonce((n) => n + 1), []);

  useEffect(() => {
    if (!trip) {
      setState({ data: null, loading: false, error: "" });
      return;
    }
    let live = true;
    setState((s) => ({ data: s.data, loading: true, error: "" }));
    const t = setTimeout(() => {
      api.post(path, trip, { params: riderId ? { rider_id: riderId } : {} })
        .then((r) => live && setState({ data: r.data, loading: false, error: "" }))
        .catch((e) => live && setState({ data: null, loading: false, error: formatApiError(e) }));
    }, 350);
    return () => {
      live = false;
      clearTimeout(t);
    };
  }, [key, nonce, riderId, path]); // eslint-disable-line react-hooks/exhaustive-deps

  return { ...state, retry };
}
